import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
interface SalesState {
  price: number;
  amount: number;
  title: string;
  image: string;
}

const initialState: SalesState = {
  price: 0,
  amount: 0,
  title: "",
  image: "",
};

export const salesSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateSalesState(state, action) {
      state.price = action.payload.price;
      state.amount = action.payload.amount;
      state.title = action.payload.title;
      state.image = action.payload.image;
    },
    resetSalesSlice: (state) => initialState,
  },
});

export const salesActions = salesSlice.actions;

export default salesSlice.reducer;
